import styled, { css } from 'styled-components';
import { rem } from 'polished';
import bglogin from '../../../../assets/images/bglogindark.png';
import Icon from '../../core/Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const a3milStyles = css`
  .login-credentials {
    max-width: ${rem('365px')};
  }

  .login-buttons {
    max-width: ${rem('365px')};
  }
  .login-msj {
    max-width: ${rem('365px')};
  }
`;

const widgetStyles = css`
  .login-label {
    color: ${props => props.theme.colors.light};
  }
  .login-buttons {
    flex-direction: column;
  }

  .login-enter {
    margin-bottom: ${rem('10px')};
    height: ${rem('40px')};
  }
  .login-enter--password {
    order: 2;
  }
`;

// Fondo del login
export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
  background-image: url(${bglogin});
  background-color: ${props => props.theme.colors.light};
  background-size: 17.8125rem;
  background-position: center;

  .login-credentials {
    margin: 0 auto;
    padding-top: ${rem('20px')};
  }
  .login-label {
    text-align: left;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('14px')};
  }
  .login-label-active-directory {
    text-align: center;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('14px')};
    margin-bottom: 15%};
  }
  .login-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto ${rem('20px')} auto;
    ${mediaqueries.greaterThan('mobile')`
      flex-direction: row;
   `};
  }
  .login-msj {
    margin: 0 auto;
  }
  .login-enter {
    height: auto;
    margin-bottom: ${rem('15px')};
    line-height: ${rem('20px')};
    &:hover {
      color: ${props => props.theme.colors.primary};
      text-decoration: underline;
    }
    ${mediaqueries.greaterThan('mobile')`
      margin-bottom: 0;     
   `};
  }
  .login-enter--start {
    order: 1;
    ${mediaqueries.greaterThan('mobile')`
      order: 2;
   `};
  }
  .login-enter--password {
    order: 2;
    ${mediaqueries.greaterThan('mobile')`
      order: 1;
      max-width: ${rem('242px')};
   `};
  }

  ${props => (props.isWidget ? widgetStyles : a3milStyles)}
`;
// Capa blanca central
export const StyledWrapperLogin = styled.div`
  background-color: ${props => props.theme.colors.light};
  width: 100%;
  max-width: ${rem('315px')};
  ${props =>
    !props.isWidget &&
    css`
      padding: 3rem 0.9375rem;
      box-shadow: 0px 0px 0.9375rem 0.3125rem rgba(0, 0, 0, 0.3);
      margin: 0.9375rem;
      max-width: 39.375rem;
    `}
  text-align: center;
`;
// Texto de Bienvenida
export const StyledTextLogin = styled.h2`
  font-size: 1rem;
  ${props =>
    !props.isWidget &&
    css`
      text-transform: uppercase;
    `}
  margin: 2rem 0 0.8rem;
`;
// Logo de a3mil
export const StyledLogo = styled(Icon)`
  display: block-inline;
  width: 18.8125rem;
  ${mediaqueries.greaterThan('mobile')`
    width: 21.625rem;
  `};
`;
// Logo de la navaja
export const StyledLogoRazor = styled(Icon)`
  display: block-inline;
  width: 3.75rem;
  ${mediaqueries.greaterThan('mobile')`
    width: 7.5rem;
  `};
`;
